import { render, staticRenderFns } from "./ExamsIdentifiedSuccess.partial.vue?vue&type=template&id=61a2bd9a&scoped=true"
import script from "./ExamsIdentifiedSuccess.partial.vue?vue&type=script&lang=js"
export * from "./ExamsIdentifiedSuccess.partial.vue?vue&type=script&lang=js"
import style0 from "./ExamsIdentifiedSuccess.partial.vue?vue&type=style&index=0&id=61a2bd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2bd9a",
  null
  
)

export default component.exports